import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import constants from '../constants'
import * as actions from '../store/slices'

const DEVICE_NAME_BY_PROGRAM = {
  [constants.CARE_PROGRAM_TYPE.DIASENS]: 'diasens',
  [constants.CARE_PROGRAM_TYPE.GLUCOLIVE]: 'glucolive',
}

const useProceedButton = ({ isLastStep, onMoveNext, onSkip, btnText }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const activeSupportProgramType = useSelector(
    (state) => state.cgm.activeSupportProgramType,
  )
  const deviceName = DEVICE_NAME_BY_PROGRAM[activeSupportProgramType]
  const shouldSetDeviceName = Boolean(deviceName)
  const buttonText =
    btnText ||
    (isLastStep && !shouldSetDeviceName ? "Let's get started" : 'Continue')

  const handleSetDeviceName = () => {
    return new Promise((resolve, reject) => {
      dispatch(
        actions.setCgmDeviceNameRequest({
          deviceName,
          resolve,
          reject,
        }),
      )
    })
  }

  const handleProceed = async () => {
    if (shouldSetDeviceName && isLastStep) {
      setLoading(true)
      try {
        await handleSetDeviceName()
      } catch (error) {
        console.error('Failed to set device name:', error)
      } finally {
        setLoading(false)
      }
    }
    onMoveNext()
  }

  const handleSkip = async () => {
    if (shouldSetDeviceName && isLastStep) {
      setLoading(true)
      try {
        await handleSetDeviceName()
      } catch (error) {
        console.error('Failed to set device name:', error)
      } finally {
        setLoading(false)
      }
    }
    onSkip()
  }

  return {
    loading,
    handleProceed,
    handleSkip,
    buttonText,
  }
}

export default useProceedButton
